//extracted by mini-css-extract-plugin
export default {"notificationsButton":"styles_notificationsButton__td3XG","lightColor":"styles_lightColor__o0YQa","notificationsUnreadCountBadge":"styles_notificationsUnreadCountBadge__f4wIk"};;